import Keycloak from "keycloak-js";

/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// This is the file for the Keycloak integration.                                                                      //
// It is good practice to have two configurations to be able to test both the local and the deployed versions.         //
// Push the deployment configuration on the VM - comment it and uncomment the local configuration for local testing.   //
//                                                                                                                     //
// The configuration requires the Realm, the Keycloak deployment link and the client ID.                               //
/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////


// // Localhost configuration
// const my_keycloak = new Keycloak({
//     "realm": "DEDALUS", // INERGY for testing purposes - change with yours
//     "url": "https://keycloak.toolbox.epu.ntua.gr", // INERGY for testing purposes - change with yours
//     "clientId": "dedalus_flexibility_tool_dev" // INERGY for testing purposes - change with yours
// })

// Deployment configuration
const my_keycloak = new Keycloak({
    "realm": "DEDALUS", // INERGY for testing purposes - change with yours
    "url": "https://keycloak.toolbox.epu.ntua.gr", // INERGY for testing purposes - change with yours
    "clientId": "dedalus_flexibility_tool_deploy" // INERGY for testing purposes - change with yours
})

export default my_keycloak